import { render } from "./MenuTableCellInputTel.vue?vue&type=template&id=095116ff"
import script from "./MenuTableCellInputTel.vue?vue&type=script&lang=js"
export * from "./MenuTableCellInputTel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__